export default __webpack_public_path__ + "static/media/ML.7c76e887.png";